import React, { useEffect, useState } from "react";
import AddStaff from "./AddStaff";
import ReactPaginate from "react-paginate";
import DateConverter from "@heartinz/date_and_time_processor";
import { Skeleton } from "@mui/material";
import { useNetwork } from "../../../../context/NetworkContext";
import handleError from "../../../../constants/handleError";
import { useShowAlert } from "../../../../context/AlertContext";
import AxiosInstance from "../../../../utils/AxiosInstance";

import { Tooltip } from "@mui/material";
import { useAuth } from "../../../../context/AuthProvider";
import uRLs from "../../../../utils/baseUtils";
import { usePermission } from "../../../../context/PermissionContext";
import Table from "../../../../constants/Table";
import { AddIcon, CloseIcon, EditIcon, KeyIcon, SearchIcon } from "../../../../constants/Icons";

function StaffControl() {
  const { isUser, settings } = useAuth();
  const { activeStoreModules, viewOption } = usePermission();
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [activeStaffId, setActiveStaffId] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [availableModules, setAvailableModules] = useState([]);
  const toggleItems = [
    {
      key: "customer",
      label: "Customer",
      icon: "ng ng-ng-customers-icon",
      bgColor: "bg-label-infoss",
    },
    ...(activeStoreModules("PASSWORD")
      ? [
          {
            key: "password",
            label: "Password",
            bgColor: "bg-label-pink-soft",
            font: "font-22",
            icon: "bx bx-key",
          },
        ]
      : []),
    {
      key: "suppiler",
      label: "Suppiler",
      font: "font-20",
      bgColor: "bg-label-supplier",
      icon: "bi bi-truck",
    },
    ...(activeStoreModules("PURCHASE")
      ? [
          {
            key: "purchase",
            label: "Purchase",
            font: "font-20",
            bgColor: "bg-label-deep-purple",
            icon: "bx bxs-purchase-tag",
          },
        ]
      : []),
    {
      key: "product",
      label: "Product",
      font: "font-13",
      bgColor: "bg-label-navy",
      icon: "ng ng-ng-product-icon",
    },
    {
      key: "stock",
      label: "Stock",
      icon: "ng ng-ng-stock-icon",
      bgColor: "bg-label-spring",
      font: "font-18",
      permission:
        isUser?.stype === "SUB"
          ? [
              {
                key: "addDirect",
                label: "Add Direct Stock",
                dotColor: "#379237",
              },
              {
                key: "addnewStock",
                label: "New Direct Stock",
                dotColor: "#379237",
              },
            ]
          : [{ key: "stockadd", label: "Add Stock ", dotColor: "#379237" }],
    },
    ...(activeStoreModules("STOCKTRANSFER")
      ? [
          {
            key: "stocktransfer",
            label: "Stock Transfer",
            icon: "bx bx-transfer",
            bgColor: "bg-label-sun",
            font: "font-20",
          },
        ]
      : []),
    {
      key: "service",
      label: "Service",
      icon: "bx bx-notepad",
      bgColor: "bg-service",
      font: "font-20",
    },

    ...(activeStoreModules("RECHARGE")
      ? [
          {
            key: "recharge",
            label: "Recharge",
            font: "font-20",
            bgColor: "bg-label-info",
            icon: "bx bx-dollar-circle",
          },
        ]
      : []),

    ...(activeStoreModules("PRESALE")
      ? [
          {
            key: "presale",
            label: "Pre Sale",
            font: "font-18",
            icon: "bi bi-file-earmark-text",
            bgColor: "btn-porforma",
            permission: [
              // { key: 'addsale', label: 'Add Sale ' },
              // {
              //   key: "preSaleList",
              //   label: "List PreSale",
              //   icon: "bx bx-chevron-right",
              //   dotColor: "#3f51b5",
              // },
              {
                key: "preSaleUpdate",
                label: "Edit Pre Sale ",
                icon: "bx bx-chevron-right",
                dotColor: "#3f51b5",
              },
              {
                key: "PreSaleDelete",
                label: "Delete Pre Sale ",
                icon: "bx bx-chevron-right",
                dotColor: "#3f51b5",
              },
            ],
          },
        ]
      : []),

    {
      key: "sale",
      label: "Sale",
      font: "font-18",
      icon: "ng ng-ng-negobill_icon",
      bgColor: "bg-label-primary",
      permission: [
        // { key: 'addsale', label: 'Add Sale ' },
        {
          key: "listsale",
          label: "All List Sale",
          icon: "bx bx-chevron-right",
          dotColor: "#3f51b5",
        },
        {
          key: "liststaffsale",
          label: "Staff  List Sale ",
          icon: "bx bx-chevron-right",
          dotColor: "#3f51b5",
        },
        {
          key: "editsale",
          label: "Edit Sale ",
          icon: "bx bx-chevron-right",
          dotColor: "#3f51b5",
        },
        {
          key: "deletesale",
          label: "Delete Sale ",
          icon: "bx bx-chevron-right",
          dotColor: "#3f51b5",
        },
        {
          key: "salehistory",
          label: "Sale History",
          icon: "bx bx-chevron-right",
          dotColor: "#3f51b5",
        },
      ],
    },
    {
      key: "returnSale",
      label: "Return Sale",
      font: "font-20",
      bgColor: "bg-label-warning",
      icon: "bx bx-undo",
    },

    ...(activeStoreModules("JOBCARD")
      ? [
          {
            key: "jobcard",
            label: "Job Card",
            font: "font-20",
            bgColor: "bg-label-primary",
            icon: "bx bx-id-card",
          },
        ]
      : []),

    ...(activeStoreModules("PROJECT")
      ? [
          {
            key: "project",
            label: "Project",
            font: "font-20",
            bgColor: "btn-project",
            icon: "bi bi-hammer",
          },
        ]
      : []),

    ...(activeStoreModules("ESTIMATE")
      ? [
          {
            key: "estimate",
            label: "Estimation",
            icon: "bx bx-notepad",
            bgColor: "bg-label-deep-purple",
            font: "font-20",
            permission: [
              {
                key: "listestimate",
                label: "List Estimate",
                icon: "bx bx-chevron-right",
                dotColor: "#ab47bc",
              },
            ],
          },
        ]
      : []),
    {
      key: "expense",
      label: "Expense",
      font: "font-20",
      bgColor: "bg-label-expense",
      icon: "ng ng-ng-expence-icon",
    },
    {
      key: "boxcash",
      label: "Box Cash",
      font: "font-20",
      bgColor: "bg-label-danger",
      icon: "bx bx-money",
    },

    // ...(activeStoreModules("SALERETURN")
    // ? [

    //   ]
    // : []),
    //  { key: 'quicksale', label: 'Quick Sale', icon: 'bx bx-cube', color: 'text-secondary' },
    {
      key: "paylater",
      label: "Pay Later",
      icon: "bx bx-timer",
      bgColor: "bg-pay-later",
      font: "font-20",
    },
    ...(activeStoreModules("REPORT")
      ? [
          {
            key: "report",
            label: "Report",
            font: "font-20",
            bgColor: "bg-report",
            icon: "bx bx-bar-chart-alt-2",
            permission: [
              // { key: 'addsale', label: 'Add Sale ' },
              ...(viewOption("reportSettings", "isServiceDoneByReport")
                ? [
                    {
                      key: "servicedonebyreport",
                      label: "Service Done By Report",
                      icon: "bx bx-chevron-right",
                      dotColor: "#2d7a4d",
                    },
                  ]
                : []),
              {
                key: "salereport",
                label: "Sale Report",
                icon: "bx bx-chevron-right",
                dotColor: "#2d7a4d",
              },
              {
                key: "stockreport",
                label: "Stock Report ",
                icon: "bx bx-chevron-right",
                dotColor: "#2d7a4d",
              },
              {
                key: "gstr1report",
                label: "GSTR1 Report ",
                icon: "bx bx-chevron-right",
                dotColor: "#2d7a4d",
              },
              {
                key: "hsnreport",
                label: "HSN Report",
                icon: "bx bx-chevron-right",
                dotColor: "#2d7a4d",
              },
              {
                key: "productreport",
                label: "Product Report ",
                icon: "bx bx-chevron-right",
                dotColor: "#2d7a4d",
              },
              {
                key: "expencereport",
                label: "Expence Report ",
                icon: "bx bx-chevron-right",
                dotColor: "#2d7a4d",
              },
              {
                key: "profitandloss",
                label: "Profit And Loss ",
                icon: "bx bx-chevron-right",
                dotColor: "#2d7a4d",
              },
            ],
          },
        ]
      : []),
    ...(activeStoreModules("ANALYTICS")
      ? [
          {
            key: "analytics",
            label: "Analytics",
            font: "font-20",
            bgColor: "bg-analytics ",
            icon: "bx bx-analyse",
          },
        ]
      : []),
    {
      key: "voucher",
      label: "Voucher",
      icon: "bx bx-file",
      bgColor: "bg-label-honey",
      font: "font-20",
    },
    //  { key: 'settings', label: 'Setting', icon: 'bx bx-cog', color: 'text-secondary' },
    //  { key: 'staff', label: 'Staff', icon: 'bx bx-user', color: 'text-indigo  ' },
    //  { key: 'storeprofile', label: 'Store Profile', icon: 'bx bx-store', color: 'text-primary' },
    //  { key: 'dashboard', label: 'Dashbord', icon: 'bx bx-home', color: 'text-purple' },
    //  { key: 'storedeletion', label: 'Store Deletion', icon: 'bx bx-trash', color: 'text-danger' },
  ];
  const permissionGroupMap = {
    customer: "CUSTOMER_ADMIN",
    password: "PASSWORD_ADMIN",
    suppiler: "SUPPLIER_ADMIN",
    purchase: "PURCHASE_ADMIN",
    product: "PRODUCT_ADMIN",
    sale: "SALE_ADMIN",
    stock: "STOCK_ADMIN",
    estimate: "ESTIMATE_ADMIN",
    expense: "EXPENSE_ADMIN",
    boxcash: "BOXCASH_ADMIN",
    recharge: "RECHARGE_ADMIN",
    returnSale: "SALERETURN_ADMIN",
    paylater: "PAYLATER_ADMIN",
    report: "REPORT_ADMIN",
    settings: "SETTINGS_ADMIN",
    quicksale: "QUICKSALE_ADMIN",
    staff: "STAFF_ADMIN",
    stocktransfer: "STOCKTRANSFER_ADMIN",
    storeprofile: "STOREPROFILE_ADMIN",
    dashboard: "DASHBOARD_ADMIN",
    storedeletion: "STOREDELETION_ADMIN",
    stockadd: "STOCK:add",
    addDirect: "STOCK:addDirect",
    addnewStock: "STOCK:createAndAddDirect",
    addsale: "SALE:add",
    listsale: "SALE:list",
    liststaffsale: "SALE:listByStaff",
    deletesale: "SALE:delete",
    editsale: "SALE:update",
    analytics: "ANALYTICS_ADMIN",
    service: "SERVICE_ADMIN",
    listestimate: "ESTIMATE:list",
    jobcard: "JOBCARD_ADMIN",
    voucher: "VOUCHER_ADMIN",
    salereport: "REPORT:getSale",
    stockreport: "REPORT:getStock",
    gstr1report: "REPORT:getGstr1",
    hsnreport: "REPORT:getHsn",
    productreport: "REPORT:getSaleProductByProductId",
    expencereport: "EXPENSE:viewReport",
    profitandloss: "REPORT:getProfitLoss",
    servicedonebyreport: "REPORT:getServiceDoneBy",
    salehistory: "SALE:history",
    presale: "PRESALE_ADMIN",
    preSaleList: "PRESALE:list",
    preSaleUpdate: "PRESALE:update",
    PreSaleDelete: "PRESALE:delete",
    project: "PROJECT_ADMIN",
  };
  const initialToggleState = toggleItems.reduce((acc, item) => {
    acc[item.key] = false;
    return acc;
  }, {});

  const [toggles, setToggles] = useState(initialToggleState);
  const [loading, setLoading] = useState(initialToggleState);

  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const perPage = 10;

  const useModal = () => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    return {
      isOpen,
      openModal,
      closeModal,
    };
  };

  const addModal = useModal();
  const editModal = useModal();
  const sidebarModal = useModal();

  const handleSidebarClose = () => {
    setActiveStaffId(null);
    sidebarModal.closeModal();
  };

  const handleToggleChange = async (key) => {
    // if (loading[key]) return;
    const groupId = permissionGroupMap[key];
    const staffId = selectedStaff?._id;

    if (!groupId || !staffId) {
      showAlert("warning", "Invalid permission group or staff");
      return;
    }

    const action = toggles[key] ? "DISABLE" : "ENABLE";
    setLoading((prev) => ({ ...prev, [key]: true }));

    try {
      const response = await AxiosInstance.post("permissions/group", {
        staffId,
        groupId,
        action,
      });
      setToggles((prev) => ({ ...prev, [key]: !prev[key] }));
      showAlert("success", response.data.message);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value.replace(/\s+/g, " ").trimStart().toLowerCase();
    setSearchQuery(query);

    if (query === "") {
      setFilteredData(originalData);
    } else {
      const filtered = originalData.filter(
        (item) =>
          item.staffName?.toLowerCase().includes(query) ||
          item.userName?.toLowerCase().includes(query),
      );
      setFilteredData(filtered);
    }
  };

  const handleView = async (staff) => {
    setSelectedStaff(staff);
    setActiveStaffId(staff._id);

    try {
      const response = await AxiosInstance.get(`permissions/${staff._id}`);
      const permissionGroups = response.data.results?.permissionGroups || [];
      const permissionBlocked = response.data.results?.permissionBlocked || [];
      const permissionToKey = {};
      Object.entries(permissionGroupMap).forEach(([key, group]) => {
        permissionToKey[group] = key;
      });

      const updatedToggles = toggleItems.reduce((acc, item) => {
        const group = permissionGroupMap[item.key];
        acc[item.key] = permissionGroups.includes(group);

        if (item.permission) {
          item.permission.forEach((sub) => {
            const subGroup = permissionGroupMap[sub.key];
            const isBlocked = permissionBlocked.includes(subGroup);
            acc[sub.key] = !isBlocked;
          });
        }
        return acc;
      }, {});

      setToggles(updatedToggles);
      sidebarModal.openModal();
    } catch (err) {
      handleError(err, showAlert);
    }
  };

  const handleEdit = (staff) => {
    setSelectedStaff(staff);
    editModal.openModal();
  };

  const handleListStaff = async (page = 0) => {
    setIsLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/staff?pageno=${page + 1}&limit=${perPage}`,
      );
      setFilteredData(response.data.results);
      setOriginalData(response.data.results);
      if (response.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const handlelistPermission = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`permissions`);
      const permissionGroups = response.data.results?.permissionGroups || [];

      const inactiveModuleKeys =
        settings.activeStoreModules
          ?.filter((module) => module.status === "INACTIVE")
          ?.map((module) => module.moduleKey.toLowerCase()) || [];

      const modules = [
        ...new Set(
          permissionGroups
            .map((pg) => pg.module.toLowerCase())
            .filter((module) => !inactiveModuleKeys.includes(module)),
        ),
      ];

      setAvailableModules(modules);
      console.log(inactiveModuleKeys);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSubToggleChange = async (subKey) => {
    const permissionKey = permissionGroupMap[subKey];
    const staffId = selectedStaff?._id;

    if (!permissionKey || !staffId) {
      showAlert("warning", "Invalid permissionKey or staff");
      return;
    }

    // Capture desired state without updating UI yet
    const desiredState = !toggles[subKey];
    const action = desiredState ? "UNBLOCK" : "BLOCK";

    setLoading((prev) => ({ ...prev, [subKey]: true }));

    try {
      const response = await AxiosInstance.patch("permissions/block", {
        staffId,
        permissionKey,
        action,
      });

      // Only update state after successful API response
      setToggles((prev) => ({ ...prev, [subKey]: desiredState }));
      showAlert("success", response.data.message);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, [subKey]: false }));
    }
  };

  // const filteredToggleItems = toggleItems.filter(item => availableModules.includes(item.key));
  const filteredToggleItems = toggleItems.filter((item) => {
    // if (!availableModules.includes(item.key)) return false;
    // if (item.key === "product") {
    //   return isUser?.stype === "MAIN";
    // }
    if (item.key === "service") {
      return uRLs.SERVICE === "true";
    }
    if (item.key === "suppiler") {
      return uRLs.SUPPLIER === "true";
    }
    if (item.key === "purchase") {
      return uRLs.PURCHASE === "true";
    }
    if (item.key === "estimate") {
      return uRLs.ESTIMATE_MODULE === "true";
    }
    if (item.key === "expense") {
      return uRLs.EXPENSE_MODULE === "true";
    }
    if (item.key === "recharge") {
      return uRLs.RECHARGE_MODULE === "true";
    }
    if (item.key === "returnSale") {
      return uRLs.RETURN_SALE === "true";
    }
    if (item.key === "report") {
      return uRLs.REPORTS_MODULE === "true";
    }
    if (item.key === "analytics") {
      return uRLs.ANALYTICS === "true";
    }
    if (item.key === "jobcard") {
      return uRLs.JOBCARD === "true";
    }
    if (item.key === "password") {
      return uRLs.DASHBOARD_PASSWORD === "true";
    }
    if (item.key === "voucher") {
      return uRLs.VOUCHER === "true";
    }
    return true;
  });
  const capitalizeFirstLetter = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

  useEffect(() => {
    handlelistPermission();
  }, []);

  useEffect(() => {
    handleListStaff(currentPage);
  }, [currentPage]);

  return (
    <>
      <div className="page-breadcrumb d-flex align-items-center mb-2">
        <div className="breadcrumb-title pe-3">Staff Access</div>
      </div>

      <div className="row">
        <div className="col-12 col-md-8">
          <div className="card radius-10 mb-0">
            <div className="card-body px-0">
              <div className="row px-3">
                <div className="col-lg-7 col-12 ">
                  <div className="position-relative">
                    <div className="input-group">
                      <input
                        type="search"
                        className="form-control"
                        autoComplete="off"
                        placeholder="Search "
                        value={searchQuery}
                        onChange={handleSearch}
                        autoFocus
                        name="staff-search"
                        id="staff-search-input"
                      />
                      <button className="input-group-text">
                        <SearchIcon/>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-12 d-flex justify-content-end ">
                  <button
                    type="button"
                    className="btn btn-primary mt-2 mt-lg-0"
                    onClick={addModal.openModal}
                  >
                    <AddIcon/> New Staff
                  </button>
                </div>
              </div>

              <Table
                loading={isLoading}
                data={filteredData}
                hoverRow={false}
                columns={[
                  {
                    label: "S.No",
                    thClass: "w-8",
                    render: (_, index) =>
                      totalItems - currentPage * perPage - index,
                  },
                  {
                    label: "Date Added",
                    thClass: "w-8",
                    render: (item) =>
                      item?.createdAt && (
                        <span>
                          {
                            DateConverter.ISOToDisplayFormat(
                              DateConverter.convertToTimeZone(
                                item?.createdAt,
                                isUser?.timezone,
                              ),
                            ).date
                          }
                        </span>
                      ),
                  },
                  {
                    label: "Name",
                    render: (item) =>
                      capitalizeFirstLetter(item?.staffName || ""),
                  },
                  {
                    label: "User Name",
                    render: (item) => item?.userName || "",
                  },
                  {
                    label: "Actions",
                    thClass: "w-8",
                    render: (item) => (
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <span className="order-actions">
                          <button
                            type="button"
                            className="btn-label-primary shadow-none me-2"
                            onClick={() => handleEdit(item)}
                          >
                            <EditIcon/>
                          </button>
                        </span>
                        <button
                          type="button"
                          className={`btn btn-deep-gray mt-2 mt-lg-0 ${
                            activeStaffId === item._id ? "active" : ""
                          }`}
                          onClick={() => handleView(item)}
                        >
                          <KeyIcon/> Access
                        </button>
                      </div>
                    ),
                  },
                ]}
              />

              {totalPages > 0 && (
                <div className="d-flex justify-content-center mt-3">
                  <ReactPaginate
                    previousLabel={"← Pre"}
                    nextLabel={"Next →"}
                    breakLabel={"..."}
                    onPageChange={({ selected }) => {
                      setIsLoading(true);
                      setSearchQuery("");
                      setCurrentPage(selected);
                    }}
                    pageRangeDisplayed={5}
                    pageCount={totalPages}
                    containerClassName="pagination"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    activeClassName="active"
                    forcePage={currentPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {sidebarModal.isOpen && (
          <div className="col-12 col-md-4">
            <div className="card ">
              <div
                className="card-header  d-flex align-items-center p-2 border-bottom"
                style={{ background: "#e0e0e0" }}
              >
                <div className="">Access Management</div>
                <div className="view-actions ms-auto">
                  <button type="button" onClick={handleSidebarClose}>
                    {" "}
                    <Tooltip title="Close" arrow>
                      <CloseIcon/>
                    </Tooltip>
                  </button>
                </div>
              </div>
              <div className="row p-2">
                <div class="col-lg-12  mb-2">
                  <div class="card shadow-none border mb-0">
                    {/* <div class="card-header bg-primary p-2">
                              <div class="mb-0 text-primary">Staff Info</div>
                            </div> */}

                    <div class="card-body px-2 py-0">
                      <p class="my-1 fs-13">
                        Name:{" "}
                        <span class="fw-600 fs-14">
                          {capitalizeFirstLetter(selectedStaff?.staffName)}
                        </span>
                      </p>
                      <p class="my-1 fs-13">
                        User Name:{" "}
                        <span class="fw-600 fs-14">
                          {selectedStaff?.userName}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="card shadow-none border-0 mb-0 staff-access-card">
                    <div
                      className="card-header  border-0 p-2"
                      style={{ background: "#e0e0e0" }}
                    >
                      <div className="fw-600 ">Permissions</div>
                      <p className="mb-0 text-muted font-13">
                          Control what this staff member can access
                        </p>
                    </div>

                    <div className="card-body p-2">
                      <div
                        className="permission-scroll scroll-thin"
                        style={{
                          maxHeight: "calc(100vh - 260px)",
                          overflowY: "auto",
                        }}
                      >
                        {filteredToggleItems.map(
                          ({
                            key,
                            label,
                            icon,
                            color,
                            bgColor,
                            font,
                            permission = [],
                          }) => (
                            <div
                              className="permission-card mb-1 p-1 "
                              key={key}
                            >
                              {/* MAIN PERMISSION */}
                              <div className="d-flex align-items-center p-0">
                                <div
                                  className={` permission-icon-wrapper  d-flex justify-content-center align-items-center
                                ${toggles[key] ? bgColor : ""}
                                  `}
                                >
                                  <i
                                    className={`${icon} ${color} ${font ? font : "font-14"} permission-icon ${
                                      key === "product" ? "fs-6" : ""
                                    }`}
                                  ></i>
                                </div>

                                <span className="fw-600 ms-3 permission-title font-13">
                                  {label}
                                </span>

                                <div className="ms-auto custom-toggle-wrapper">
                                  <label className="custom-toggle cursor-pointer">
                                    <input
                                      type="checkbox"
                                      id={`${key}Toggle`}
                                      checked={toggles[key]}
                                      onChange={() => handleToggleChange(key)}
                                      disabled={loading[key]}
                                    />

                                    <span className="slider">
                                      {loading[key] ? (
                                        <span
                                          className={`spinner-inside ${
                                            toggles[key] ? "spinner-right" : ""
                                          }`}
                                        />
                                      ) : (
                                        <>
                                          {toggles[key] && (
                                            <span className="label-on ms-0-1">
                                              ON
                                            </span>
                                          )}

                                          {!toggles[key] && (
                                            <span className="label-off ms-3">
                                              OFF
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </span>
                                  </label>
                                </div>
                              </div>

                              {/* SUB OPTIONS */}
                              {toggles[key] && permission.length > 0 && (
                                <div className="sub-permission-wrapper">
                                  {permission.map(
                                    (
                                      {
                                        key: subKey,
                                        label: subLabel,
                                        dotColor,
                                      },
                                      subIndex,
                                    ) => (
                                      <div
                                        key={subKey}
                                        className={`sub-permission-item ${
                                          subIndex !== permission.length - 1
                                            ? ""
                                            : ""
                                        }`}
                                      >
                                        <div className="d-flex align-items-center py-2">
                                          {/* DOT */}
                                          <span
                                            className={`sub-dot "}`}
                                            style={{
                                              background: dotColor || "#4f46e5",
                                            }}
                                          ></span>

                                          <span className="sub-label">
                                            {subLabel}
                                          </span>

                                          <div className="ms-auto custom-toggle-wrapper">
                                            <label className="custom-toggle custom-toggle-sm cursor-pointer">
                                              <input
                                                type="checkbox"
                                                id={`${subKey}Toggle`}
                                                checked={toggles[subKey]}
                                                onChange={() =>
                                                  handleSubToggleChange(subKey)
                                                }
                                                disabled={loading[subKey]}
                                              />

                                              <span className="slider">
                                                {loading[subKey] ? (
                                                  <span
                                                    className={`spinner-inside ${
                                                      toggles[subKey]
                                                        ? "spinner-right"
                                                        : ""
                                                    }`}
                                                  />
                                                ) : (
                                                  <>
                                                    {toggles[subKey] && (
                                                      <span className="label-on ms-0-1">
                                                        ON
                                                      </span>
                                                    )}

                                                    {!toggles[subKey] && (
                                                      <span className="label-off ms-3">
                                                        OFF
                                                      </span>
                                                    )}
                                                  </>
                                                )}
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )}
                                </div>
                              )}
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {addModal.isOpen && (
        <AddStaff
          isOpen={addModal.isOpen}
          onClose={addModal.closeModal}
          setFilteredData={setFilteredData}
          filteredData={filteredData}
          setTotalItems={setTotalItems}
          handleView={handleView}
        />
      )}
      {editModal.isOpen && (
        <AddStaff
          isOpen={editModal.isOpen}
          onClose={editModal.closeModal}
          setFilteredData={setFilteredData}
          filteredData={filteredData}
          setTotalItems={setTotalItems}
          selectedStaff={selectedStaff}
        />
      )}
    </>
  );
}

export default StaffControl;
